<template>
  <div>
    <div class="rew19_termwrap">
      <div v-show="mode == 'ARO'">
        <h4>정기구매 이용 약관</h4>
        <div v-html="aroOrderTerm" class="rew19_termbox">

        </div>
        <div class="rew19_wrapCheck_t1">
          <input
            v-model="aroApplyAgree"
            ref="aro15ApplyAgree"
            type="checkbox"
            id="term00"
            class="rew19_fakeCheck_t1"
          />
          <label for="term00">약관에 동의합니다</label>
        </div>
      </div>

      <div v-show="mode == '15ARO'">
        <h4>정기구매 스페셜 멤버십 신청약관</h4>
        <div v-html="aro15OrderTerm" class="rew19_termbox">

        </div>
        <div class="rew19_wrapCheck_t1">
          <input
            v-model="aro15ApplyAgree"
            ref="aro15ApplyAgree"
            type="checkbox"
            id="term01"rew19_termbox
            class="rew19_fakeCheck_t1"
          />
          <label for="term01">약관에 동의합니다</label>
        </div>
      </div>

      <div v-show="mode == 'NTC'">
        <h4>NTC 정기 기부 신청약관</h4>
        <div v-html="ntcOrderTerm" class="rew19_termbox">

        </div>
        <div class="rew19_wrapCheck_t1">
          <input
            v-model="ntcApplyAgree"
            ref="ntcApplyAgree"
            type="checkbox"
            id="term02"
            class="rew19_fakeCheck_t1"
          />
          <label for="term02">약관에 동의합니다</label>
        </div>
      </div>

      <!--
      <div v-show="mode != 'NTC'">
        <h4>수령 희망일 동의</h4>
        <div v-html="wishDeliveryTerm" class="rew19_termbox">

        </div>
        <div class="rew19_wrapCheck_t1">
          <input
            v-model="deliveryAgree"
            ref="deliveryAgree"
            type="checkbox"
            id="term03"
            class="rew19_fakeCheck_t1"
          />
          <label for="term03">수령 희망일에 동의합니다</label>
        </div>
      </div>
      -->

      <div v-show="cardTermsShow">
        <!--신용카드 결제인 경우-->
        <h4>신용카드 사용 동의</h4>
        <div v-html="cardUseTerm" class="rew19_termbox">

        </div>
        <div class="rew19_wrapCheck_t1">
          <input
            v-model="cardAgree"
            ref="cardAgree"
            type="checkbox"
            id="term04"
            class="rew19_fakeCheck_t1"
          />
          <label for="term04">신용카드 사용에 동의합니다</label>
        </div>
        <!--//신용카드 결제인 경우-->
      </div>

      <div v-show="!cardTermsShow">
        <!--계좌이체 결제인 경우-->
        <h4>자동 계좌이체 약관</h4>
        <div v-html="accountAgreeTerm" class="rew19_termbox">

        </div>
        <div class="rew19_wrapCheck_t1">
          <input
            v-model="accountAgree"
            ref="accountAgree"
            type="checkbox"
            id="term05"
            class="rew19_fakeCheck_t1"
          />
          <label for="term05">자동 계좌이체 약관에 동의합니다</label>
        </div>
        <!--//계좌이체 결제인 경우-->
      </div>
    </div>
    <!--//rew19_termwrap-->
  </div>
</template>
<script>
import * as Const from "@/utils/const";
export default {
  name: "Terms",
  props: {
    mode: {
      type: String,
      default: ""
    },
    paymentMode: {
      type: Number,
      default: 0 // 0:신용카드/계좌 자동이체, 2:신용카드만, 3:계좌 자동이체만
    }
  },
  data() {
    return {
      aroApplyAgree : "",
      aro15ApplyAgree: "",
      ntcApplyAgree: "",
      deliveryAgree: "",
      cardAgree: "",
      accountAgree: "",
      cardTermsShow: true,

      aroOrderTerm : "",
      aro15OrderTerm : "",
      ntcOrderTerm : "",
      wishDeliveryTerm : "",
      cardUseTerm : "",
      accountAgreeTerm : "",
    };
  },
  created(){
    let _this = this;

    _this.$http.get(_this.$aroApiBasePath + Const.VALUE_ARO_ORDER_TERM).then(res=>{
      _this.aroOrderTerm = res.data;
    });

    _this.$http.get(_this.$aroApiBasePath + Const.VALUE_15ARO_ORDER_TERM).then(res=>{
      _this.aro15OrderTerm = res.data;
    });

    _this.$http.get(_this.$aroApiBasePath + Const.VALUE_NTC_ORDER_TERM).then(res=>{
      _this.ntcOrderTerm = res.data;
    });

    // _this.$http.get(_this.$aroApiBasePath + Const.VALUE_WISH_DELIVERY_TERM).then(res=>{
    //   _this.wishDeliveryTerm = res.data;
    // });

    _this.$http.get(_this.$aroApiBasePath + Const.VALUE_ARO_CARD_USE_TERM).then(res=>{
      _this.cardUseTerm = res.data;
    });

    _this.$http.get(_this.$aroApiBasePath + Const.VALUE_BANK_ACCOUNT_REG_TERM).then(res=>{
      _this.accountAgreeTerm = res.data;
    });
  },
  methods: {
    validation() {
      let _this = this;
      if (_this.mode == 'ARO' && !_this.aroApplyAgree) {
        _this.$dialogs.alert("정기구매 신청약관에 동의해 주세요.").then(res => {
          _this.$refs.aroApplyAgree.focus();
        });
        return false;
      }

      if (_this.mode == '15ARO' && !_this.aro15ApplyAgree) {
        _this.$dialogs.alert("스마트 뷰티 멤버십 신청약관에 동의해 주세요.").then(res => {
          _this.$refs.aro15ApplyAgree.focus();
        });
        return false;
      }

      if (_this.mode == 'NTC' && !_this.ntcApplyAgree) {
        _this.$dialogs.alert("NTC 정기 기부 신청약관에 동의해 주세요.").then(res => {
          _this.$refs.ntcApplyAgree.focus();
        });
        return false;
      }


      // if (_this.mode != 'NTC' && !_this.deliveryAgree) {
      //   _this.$dialogs.alert("수령 희망일 약관에 동의해 주세요.").then(res => {
      //     _this.$refs.deliveryAgree.focus();
      //   });
      //   return false;
      // }

      if (_this.cardTermsShow && !_this.cardAgree) {
        _this.$dialogs.alert("신용카드 약관에 동의해 주세요.").then(res => {
          _this.$refs.cardAgree.focus();
        });
        return false;
      }

      if (!_this.cardTermsShow && !_this.accountAgree) {
        _this.$dialogs.alert("자동 계좌이체 약관에 동의해 주세요.").then(res => {
          _this.$refs.accountAgree.focus();
        });
        return false;
      }

      return true;
    },
    setCardTerms(val) {
      let _this = this;
      _this.cardTermsShow = val;
    },
    setDeliveryDate(deliveryDate, paymentDate){
      let _this = this;

      const regExpDD = new RegExp('<span class="tokenDD textRed">[0-9]+일<\/span>');
      const regExpPD = new RegExp('<span class="tokenPD textRed">[0-9]+일<\/span>');

      _this.$http.get(_this.$aroApiBasePath + Const.VALUE_WISH_DELIVERY_TERM).then(res=>{
        _this.wishDeliveryTerm = res.data;

        _this.wishDeliveryTerm = _this.wishDeliveryTerm.replace(regExpDD, `<span class="tokenDD textRed">${deliveryDate}일</span>`);
        _this.wishDeliveryTerm = _this.wishDeliveryTerm.replace(regExpPD, `<span class="tokenPD textRed">${paymentDate}일</span>`);
      });
    }
  }
};
</script>
<style>
.rew19_termbox table.private_table{
  width: 100%;
  border: 1px solid #aaa;
  border-collapse: collapse;
}

.rew19_termbox table.private_table th, .rew19_termbox table.private_table td {
  border: 1px solid #aaa;
}
</style>



// WEBPACK FOOTER //
// src/components/payment/Terms.vue